/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';
import { wrapSkeleton, WrapSkeletonInjectedProps } from './helpers/wrapSkeleton';

type Props = IContentLoaderProps & WrapSkeletonInjectedProps;

const EntityItemSkeletonComponent = memo<Props>(props => {
  const { style = {}, skeletonWrapper, ...otherProps } = props;
  const { wWidth = 227 } = skeletonWrapper;
  return (
    <ContentLoader
      height={52}
      width={wWidth}
      backgroundColor={skeletonConstants.backgroundColor}
      foregroundColor={skeletonConstants.foregroundColor}
      style={{
        backgroundColor: skeletonConstants.loaderBackgroundColor,
        borderRadius: skeletonConstants.loaderBorderRadius,
        ...style,
      }}
      {...otherProps}
    >
      <rect x="10" y="10" rx="6" ry="6" width="32" height="32" />
      <rect x="56" y="17" rx="6" ry="6" width={wWidth - 66} height="18" />
    </ContentLoader>
  );
});

export const EntityItemSkeleton = wrapSkeleton(EntityItemSkeletonComponent);
